<template>
  <transition name="fade" mode="out-in">
    <timeline v-if="timelineData"
      timeline-theme="#5dbecb"
    >
      <template v-for="(data, dataIndex) in timelineData">
        <timeline-title v-if="data.timelineType === 'title'" :key="data.timelineType + '_' + dataIndex" :class="{'no-future': !data.future}">
          <template #others><i class="sherpa-icon icon-calendario"></i></template>
          <span v-if="data.dayStr !== ''">{{ data.dayStr }}</span>
          <span v-else>&nbsp;</span>
        </timeline-title>
        <timeline-item v-if="data.timelineType === 'item'" :key="data.timelineType + '_' + dataIndex" :class="{'no-future': !data.future}">
          <template #others><i class="sherpa-icon icon-reloj"></i></template>
          <span class="hour-type">
            <span v-if="data.hour !== 'Invalid date'">{{ data.hour }}h</span>
            <i :class="['sherpa-icon', 'icon-timeline-' + data.type]"></i>
            <span class="title">{{ data.name }}</span>
          </span>
          <div class="event">
            <div v-if="data.thumbnail !== ''" class="thumbnail-wrapper">
              <img class="thumbnail" :src="data.thumbnail" />
            </div>
          </div>

          <!-- Definition Timeline Task Presentation -->
          <div v-if="definition.task && definition.task.length > 0" :class="[getDefinitionFieldClassTaskClass(), 'groupTasks']">
            <definition-task
              :definition="definition" :object="data.object[0]" :definitionContentId="definitionContentId" :repeatableGroupCode="getRepeatableGroupCode(data.object)" :languageSelected="languageSelected" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams"
              location="edit" :repeatableGroupPresentation="repeatableGroupPresentation" :callTask="callTask"
              @refreshDefinition="refreshDefinition" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
            />
          </div>
        </timeline-item>
      </template>
    </timeline>
  </transition>
</template>

<script>
import Timeline from '@/components/shared/timeline/Timeline.vue'
import TimelineItem from '@/components/shared/timeline/TimelineItem.vue'
import TimelineTitle from '@/components/shared/timeline/TimelineTitle.vue'
import DefinitionTask from '../task'
import transport from 'vue-definition-utils/src/utils/transport'
import moment from 'moment'

export default {
  name: 'definition-repeatable-timeline',
  props: [
    'definition',
    'object',
    'id',
    'visualDefinition',
    'definitionContentId',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'repeatableGroupPresentation',
    'callTask'
  ],
  data () {
    return {
      timelineData: null
    }
  },
  components: {
    Timeline,
    TimelineItem,
    TimelineTitle,
    DefinitionTask
  },
  beforeMount () {
    if (this.object.children) {
      this.timelineData = []

      var currentDay = null
      for (var j = 0; j < this.object.children.length; j++) {
        var responses = this.object.children[j]

        var name = this.getTimelineValue('campanaatricpgpiece', [responses])
        var date = this.getTimelineValue('dateplan', [responses])
        var type = this.getTimelineValue('typepiece', [responses])
        var thumbnail = this.getTimelineValue('thumbnail', [responses])

        if (currentDay === null ||
          (
            currentDay.date.day !== date.day ||
            currentDay.date.month !== date.month ||
            currentDay.date.year !== date.year
          )
        ) {
          currentDay = {
            'date': {
              'day': date.day,
              'month': date.month,
              'year': date.year
            },
            'dayStr': date.dateStr.substring(0, 10),
            'future': moment(date).isSame(moment().startOf('day'), 'd') || moment(date).isAfter(moment()),
            'timelineType': 'title',
            'object': [responses]
          }
          this.timelineData.push(currentDay)
        }

        this.timelineData.push({
          'name': name,
          'type': type,
          'thumbnail': thumbnail,
          'hour': date.hour,
          'timelineType': 'item',
          'future': date.future,
          'object': [responses]
        })
      }
    }
  },
  methods: {
    getTimelineValue (name, response) {
      var result
      var namePreffix = transport.methods.getFamilyCategory(response[0].id)
      var definition = transport.methods.getRequestDefinitionById(namePreffix + name, [this.definition])

      result = transport.methods.getObjectTextValue(
        this.visualDefinition.definition,
        definition,
        transport.methods.getRequestObjectById(namePreffix + name, response),
        null
      )

      if (name === 'dateplan') {
        var date = transport.methods.getDate(result, definition)

        result = {
          dateStr: result,
          day: moment(date).format('D'),
          month: moment(date).format('MM'),
          year: moment(date).format('YYYY'),
          hour: moment(date).format('HH:mm'),
          future: moment(date).isAfter(moment())
        }
      }

      return result
    },
    getDefinitionFieldClassTaskClass () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition)
      return definition.tasks
    },
    getRepeatableGroupCode (reqObj) {
      return transport.methods.getRepeatableGroupCode(reqObj[0], this.definition)
    },
    refreshDefinition (object) {
      this.$emit('refreshDefinition', object)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    }
  }
}
</script>

<style lang="scss">
.timeline {
  .repeatable {
      border-top: 0;
  }

  li {
    margin: 0 0 0 0;
    border-left: 1px dotted #5dbecb;
    padding: 14px 0 18px 28px;
    font-size: 20px;

    &.timeline-title {
      font-size: 25px;
      padding-top: 40px;
      margin-top: 0;
      color: #000 !important;
      font-style: italic !important;
      font-weight: bold !important;
      float: left;
      width: 100%;
    }
    &.timeline-title:first-child {
      padding-top: 10px;

      .timeline-circle {
        top: 12px;
      }
    }
    &.timeline-item {
      border-bottom: 0;
      float: left;
      width: 100%;

      .hour-type {
        color: #000 !important;
        font-style: italic !important;
        font-weight: bold !important;
        vertical-align: middle;
        margin-right: 15px;

        i {
          font-size: 24px;
          vertical-align: middle;
        }

        span {
          margin-right: 15px;
        }
      }

      .title {
        font-family: "Source Sans Pro", sans-serif !important;
        font-size: 16px !important;
        vertical-align: text-bottom;
        font-weight: normal !important;
        margin: 0 0 15px 10px !important;
      }

      .thumbnail-wrapper {
        padding: 8px;
        background-color: #ffffff;
        border: 1px solid #e0e0e0;
        min-height: 400px;
        max-height: 400px;
        overflow-y: hidden;
        position: relative;
        border-radius: 3px;
        width: fit-content;

        .thumbnail {
          width: 300px;
        }
      }
    }
    &.timeline-item:last-child {
      padding-bottom: 15px;
    }
    .timeline-circle {
      left: -21px;
      top: 16px;
      background-color: transparent;

      i {
        font-size: 22px;
        color: #ff7643;
      }
    }
    .timeline-title-circle {
      left: -21px;
      top: 42px;
      background-color: transparent;

      i {
        font-size: 30px;
        color: #ff7643;
      }
    }
    &.no-future.timeline-title,
    &.no-future.timeline-item {
      opacity: 0.85;

    }
  }
  .groupTasks {
    float: left;
    display: block;
    padding: 0;

    .taskDefinition,
    .taskLink {
      .w3-buttonTask {
        height: auto;

         i.sherpa-icon {
           display: none;
         }
         span {
           font-size: 14px !important;
           color: #fff !important;
           transition: all 0.2s ease-in;
           font-weight: 600;
           font-family: "Source Sans Pro", sans-serif;
         }
         span:hover {
           color: #000 !important;
         }
      }
    }
  }
}
</style>
